// extracted by mini-css-extract-plugin
export default {"footerDescription":"TermsOfUseLinks_footerDescription__o8wpr"};